export default "__VITE_ASSET__BOz6uP2t__"